/* =====================================================================
   OZARKE — PDP V2 first-load layout fix
   Fixes: on first page load, PDP V2 elements appear cramped/overlapping
   until a manual resize/reload.

   Why: some theme scripts only run their layout calculations on *actual*
   resize/load events and don't run an initial pass on first paint.

   This script:
   - Ensures body.temp-product-pdp-v2 is present whenever PDP V2 is present
   - Triggers a few safe layout "nudges" on:
       * DOMContentLoaded
       * window load
       * document fonts ready
       * hero image load
   ===================================================================== */
(function () {
  if (window.__ozPdpV2FirstLoadLayoutFixBound) return;
  window.__ozPdpV2FirstLoadLayoutFixBound = true;

  function hasPdpV2() {
    return !!document.querySelector(".pdp-hero.pdp-hero-v2");
  }

  function syncBodyClass() {
    try {
      if (!document.body) return;
      document.body.classList.toggle("temp-product-pdp-v2", hasPdpV2());
    } catch (e) {}
  }

  function fireResize() {
    try { window.dispatchEvent(new Event("resize")); } catch (e) {}
    try { window.dispatchEvent(new Event("orientationchange")); } catch (e) {}
    try { window.dispatchEvent(new Event("scroll")); } catch (e) {}
  }

  var didSchedule = false;
  function scheduleNudges() {
    if (didSchedule) return;
    didSchedule = true;

    syncBodyClass();

    // A few passes to catch late-loaded CSS/images and GSAP/ScrollTrigger setups
    requestAnimationFrame(function () { fireResize(); });
    setTimeout(function () { fireResize(); }, 150);
    setTimeout(function () { fireResize(); }, 450);
    setTimeout(function () { fireResize(); }, 900);
    setTimeout(function () { fireResize(); }, 1400);

    // When fonts finish loading, text metrics change -> reflow
    try {
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          fireResize();
          setTimeout(function () { fireResize(); }, 250);
        });
      }
    } catch (e) {}

    // When the main hero image finishes loading, layout can shift
    try {
      var imgs = document.querySelectorAll(".pdp-hero.pdp-hero-v2 img");
      for (var i = 0; i < imgs.length; i++) {
        (function (img) {
          if (!img) return;
          if (img.complete) return;
          img.addEventListener("load", function () { fireResize(); }, { once: true });
        })(imgs[i]);
      }
    } catch (e) {}
  }

  // Run on DOM ready / immediately
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleNudges);
  } else {
    scheduleNudges();
  }

  // Ensure another pass on full load (some theme listeners attach here)
  window.addEventListener("load", function () {
    syncBodyClass();
    fireResize();
    setTimeout(function () { fireResize(); }, 250);
    setTimeout(function () { fireResize(); }, 800);
  }, { once: true });

  // SPA injections: if PDP is injected after navigation, run again
  try {
    var mo = new MutationObserver(function (muts) {
      syncBodyClass();

      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        if (!added || !added.length) continue;

        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (!n || n.nodeType !== 1) continue;

          if (
            (n.matches && n.matches(".pdp-hero.pdp-hero-v2")) ||
            (n.querySelector && n.querySelector(".pdp-hero.pdp-hero-v2"))
          ) {
            didSchedule = false;
            scheduleNudges();
            return;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
